import { TERRAIN_TILE_WIDTH, TERRAIN_TILE_HEIGHT } from "../../constants"

export function generateTerrain({ offsetY }) {
  const width = TERRAIN_TILE_WIDTH
  const height = TERRAIN_TILE_HEIGHT

  const pixels = new Uint8ClampedArray(width * height * 4) // RGBA format

  for (let localY = 0; localY < height; ++localY) {
    for (let localX = 0; localX < width; localX++) {
      const solid = pixel({ x: localX, y: localY + offsetY })

      const pixelIndex = (localY * width + localX) * 4
      pixels[pixelIndex] = 0 // r
      pixels[pixelIndex + 1] = 0 // g
      pixels[pixelIndex + 2] = 0 // b
      pixels[pixelIndex + 3] = solid ? 255 : 0 // a
    }
  }

  return pixels
}

function mix(x, y, a) {
  return x * (1 - a) + y * a
}

function fract(n) {
  return n - Math.floor(n)
}

function hash(n) {
  return fract(Math.sin(n) * 43758.5453)
}

function noise(x) {
  const i = Math.floor(x)
  const f = fract(x)
  const u = f * f * (3.0 - 2.0 * f) // Smoothstep
  return mix(hash(i), hash(i + 1.0), u)
}

function fbm(x) {
  let v = 0.0
  let a = 0.5
  let freq = 1.0
  for (let i = 0; i < 4; i++) {
    v += a * noise(x * freq)
    freq *= 2.0
    a *= 0.5
  }
  return v
}

const o = 8420
const r = 400
const q = 3500
const d = 400
const p = 1.5
const j = 30.
const halfWidth = TERRAIN_TILE_WIDTH / 2
const halfQ = q / 2
const half = halfWidth - halfQ
function pixel({ x, y }) {
  const n = (y + o) / r
  const line = fbm(n) * q + half
  let distance =
	Math.abs(x - line) +
	(Math.cos(x / 6) + 1.) / 2. * 8 +
	(Math.sin((x + 2345) / 15) + 1.) / 2 * 16
  if (y < 500) // Flatten out ocean floor
    distance *= (y / 500)
  
  const m = (Math.cos(y / 100) * Math.sin(y / 100 + 999.0) + 1.0) / 2.0
  const b = d * Math.max(m, 0.5) * p

  return distance > b
}
